module.exports = __webpack_public_path__ + "static/media/toggleResistance.69021a23.gif";